/*
 * shop5-home.js - behaviours of the home page sections of the owner home design (stage 6H; docs/build/OWNER_HOME_MAP.md).
 * Loaded on the home template only, with defer after shop5.js (layout/theme.liquid, vendor edit L12); each part
 * registers with window.Shop5Parts (assets/shop5.js part 0), which starts it per section root and tears it down on
 * shopify:section:unload. Merged from the part fragments in docs/build/parts6h/ (INTEGRATION.md), in page order:
 * 1 "home-hero" and "home-pills", 2 "home-products", 3 "home-app", 4 "home-seo". Nothing runs without the registry.
 */
(function () {
  if (!window.Shop5Parts) return;
  var Shop5Parts = window.Shop5Parts;

  // 1. Hero slider and category pills (docs/build/parts6h/home-hero.js).
  /*
   * Home hero slider and category pills bar (stage 6H, part "home-hero"; sections/shop5-home-hero.liquid and
   * sections/shop5-home-pills.liquid; spec docs/build/evidence/6H/map/B-hero-pills.md sections 4 and 9).
   * Two parts: "home-hero" and "home-pills". Each is initialised per section root by Shop5Parts and returns its
   * destroy function (timers cleared, listeners and observers removed) for shopify:section:unload.
   */

  /* ---------- Part "home-hero": crossfade slider ---------- */
  Shop5Parts.register('home-hero', function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-shop5-hs-slide]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-shop5-hs-group]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-shop5-hs-thumb]'));
    var cue = root.querySelector('[data-shop5-hs-cue]');
    var count = slides.length;
    var cleanups = [];
    var timer = null;
    var observer = null;
    var cueFrame = 0;
    var pauses = {};
    var stopped = false;
    var current = 0;
    var duration = parseInt(root.getAttribute('data-duration'), 10) || 5500;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && count > 1;
    var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var touchX = 0;
    var touchY = 0;
    var touching = false;

    if (!count) {
      return function destroy() {};
    }

    slides.forEach(function (slide, i) {
      if (slide.classList.contains('is-active')) current = i;
    });

    function on(target, type, handler, options) {
      target.addEventListener(type, handler, options || false);
      cleanups.push(function () {
        target.removeEventListener(type, handler, options || false);
      });
    }

    function reduced() {
      return Boolean(motion && motion.matches);
    }

    function rtl() {
      return window.getComputedStyle(root).direction === 'rtl';
    }

    function isPaused() {
      for (var reason in pauses) {
        if (Object.prototype.hasOwnProperty.call(pauses, reason) && pauses[reason]) return true;
      }
      return false;
    }

    function schedule() {
      window.clearTimeout(timer);
      timer = null;
      if (!autoplay || stopped || reduced() || isPaused()) return;
      timer = window.setTimeout(function () {
        go(current + 1);
        schedule();
      }, duration);
    }

    function setPause(reason, value) {
      if (Boolean(pauses[reason]) === value) return;
      pauses[reason] = value;
      schedule();
    }

    /* Slides after the first carry their sources in data attributes until the page has loaded. */
    function load(slide) {
      if (!slide) return;
      var deferred = slide.querySelectorAll('[data-shop5-src], [data-shop5-srcset]');
      Array.prototype.forEach.call(deferred, function (el) {
        var srcset = el.getAttribute('data-shop5-srcset');
        var src = el.getAttribute('data-shop5-src');
        if (srcset) {
          el.setAttribute('srcset', srcset);
          el.removeAttribute('data-shop5-srcset');
        }
        if (src) {
          el.setAttribute('src', src);
          el.removeAttribute('data-shop5-src');
        }
      });
    }

    function loadAll() {
      slides.forEach(load);
    }

    function shown(el) {
      return el.getClientRects().length > 0;
    }

    function playVideos() {
      slides.forEach(function (slide, i) {
        Array.prototype.forEach.call(slide.querySelectorAll('video'), function (video) {
          if (i === current && !reduced() && shown(video)) {
            video.muted = true;
            video.playsInline = true;
            var played = video.play();
            if (played && typeof played.catch === 'function') played.catch(function () {});
          } else {
            video.pause();
          }
        });
      });
    }

    function setState(i, active) {
      var slide = slides[i];
      slide.classList.toggle('is-active', active);
      if (active && !slide.hasAttribute('data-shop5-hs-video')) slide.removeAttribute('aria-hidden');
      else slide.setAttribute('aria-hidden', 'true');
      if (groups[i]) groups[i].classList.toggle('is-active', active);
      if (thumbs[i]) {
        thumbs[i].classList.toggle('is-active', active);
        if (active) thumbs[i].setAttribute('aria-current', 'true');
        else thumbs[i].removeAttribute('aria-current');
      }
    }

    function go(index) {
      var next = ((index % count) + count) % count;
      if (next === current) return;
      load(slides[next]);
      setState(current, false);
      setState(next, true);
      current = next;
      playVideos();
    }

    /* The shopper took control: no more autoplay (WCAG 2.2.2 together with the pauses). */
    function userGo(index) {
      stopped = true;
      window.clearTimeout(timer);
      timer = null;
      go(index);
    }

    /* Thumbnails: click, and arrow keys along the strip (column on desktop, row on phones). */
    thumbs.forEach(function (thumb, i) {
      on(thumb, 'click', function () {
        userGo(i);
      });
      on(thumb, 'keydown', function (event) {
        var forward = rtl() ? 'ArrowLeft' : 'ArrowRight';
        var backward = rtl() ? 'ArrowRight' : 'ArrowLeft';
        var target = -1;
        if (event.key === 'ArrowDown' || event.key === forward) target = (i + 1) % count;
        else if (event.key === 'ArrowUp' || event.key === backward) target = (i - 1 + count) % count;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = count - 1;
        if (target < 0 || !thumbs[target]) return;
        event.preventDefault();
        userGo(target);
        thumbs[target].focus();
      });
    });

    /* Pauses: pointer over the hero, focus inside it, a finger down, a hidden tab, the hero off screen. */
    on(root, 'pointerenter', function (event) {
      if (event.pointerType === 'mouse') setPause('hover', true);
    });
    on(root, 'pointerleave', function (event) {
      if (event.pointerType === 'mouse') setPause('hover', false);
    });
    on(root, 'focusin', function () {
      setPause('focus', true);
    });
    on(root, 'focusout', function (event) {
      if (!event.relatedTarget || !root.contains(event.relatedTarget)) setPause('focus', false);
    });
    on(document, 'visibilitychange', function () {
      setPause('hidden', document.hidden);
    });

    /* Swipe: a horizontal move over 40 px; "next" follows the reading direction. */
    on(root, 'touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) return;
      touching = true;
      touchX = event.touches[0].clientX;
      touchY = event.touches[0].clientY;
      setPause('touch', true);
    }, { passive: true });
    on(root, 'touchend', function (event) {
      if (!touching) return;
      touching = false;
      var point = event.changedTouches && event.changedTouches[0];
      setPause('touch', false);
      if (!point || count < 2) return;
      var dx = point.clientX - touchX;
      var dy = point.clientY - touchY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        var forward = rtl() ? dx > 0 : dx < 0;
        userGo(current + (forward ? 1 : -1));
      }
    }, { passive: true });
    on(root, 'touchcancel', function () {
      touching = false;
      setPause('touch', false);
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          setPause('offscreen', !entry.isIntersecting);
          if (entry.isIntersecting) playVideos();
        });
      });
      observer.observe(root);
    }

    if (motion) {
      var onMotion = function () {
        schedule();
        playVideos();
      };
      if (motion.addEventListener) {
        motion.addEventListener('change', onMotion);
        cleanups.push(function () {
          motion.removeEventListener('change', onMotion);
        });
      } else if (motion.addListener) {
        motion.addListener(onMotion);
        cleanups.push(function () {
          motion.removeListener(onMotion);
        });
      }
    }

    /* Theme editor: a selected slide block is shown and holds still until it is deselected. */
    on(root, 'shopify:block:select', function (event) {
      var slide = event.target && event.target.closest ? event.target.closest('[data-shop5-hs-slide]') : null;
      if (!slide) return;
      load(slide);
      go(slides.indexOf(slide));
      setPause('editor', true);
    });
    on(root, 'shopify:block:deselect', function () {
      setPause('editor', false);
    });

    /* Scroll cue: fades out once the page has scrolled. */
    if (cue) {
      var updateCue = function () {
        cueFrame = 0;
        cue.classList.toggle('is-hidden', (window.pageYOffset || document.documentElement.scrollTop) > 40);
      };
      on(window, 'scroll', function () {
        if (!cueFrame) cueFrame = window.requestAnimationFrame(updateCue);
      }, { passive: true });
      updateCue();
    }

    /* Overlay test: ?shop5-slide=N or #shop5-slide=N (or data-shop5-freeze="N" on the section) freezes slide N. */
    var freeze = /[?&#]shop5-slide=(\d+)/.exec(window.location.search + window.location.hash);
    var frozen = freeze ? parseInt(freeze[1], 10) : parseInt(root.getAttribute('data-shop5-freeze') || '', 10);
    if (frozen >= 1 && frozen <= count) {
      root.classList.add('shop5-hs--frozen');
      stopped = true;
      loadAll();
      go(frozen - 1);
    }

    if (document.readyState === 'complete') {
      loadAll();
    } else {
      on(window, 'load', loadAll);
    }

    playVideos();
    schedule();

    return function destroy() {
      window.clearTimeout(timer);
      timer = null;
      if (cueFrame) window.cancelAnimationFrame(cueFrame);
      if (observer) observer.disconnect();
      cleanups.forEach(function (cleanup) {
        cleanup();
      });
      cleanups = [];
      Array.prototype.forEach.call(root.querySelectorAll('video'), function (video) {
        video.pause();
      });
    };
  });

  /* ---------- Part "home-pills": scrolling row of category pills ---------- */
  Shop5Parts.register('home-pills', function (root) {
    var track = root.querySelector('[data-shop5-pills-track]');
    var previous = root.querySelector('[data-shop5-pills-prev]');
    var next = root.querySelector('[data-shop5-pills-next]');
    var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var cleanups = [];
    var resizeObserver = null;
    var drag = null;
    var suppressClick = false;

    if (!track) {
      return function destroy() {};
    }

    function on(target, type, handler, options) {
      target.addEventListener(type, handler, options || false);
      cleanups.push(function () {
        target.removeEventListener(type, handler, options || false);
      });
    }

    function rtl() {
      return window.getComputedStyle(track).direction === 'rtl';
    }

    function update() {
      root.classList.toggle('is-overflowing', track.scrollWidth > track.clientWidth + 1);
    }

    /* "Previous" scrolls toward the start of the reading direction, "next" toward its end, by 60 % of the width. */
    function scrollByPage(towardStart) {
      var distance = Math.round(track.clientWidth * 0.6);
      var sign = towardStart ? (rtl() ? 1 : -1) : (rtl() ? -1 : 1);
      track.scrollBy({ left: sign * distance, behavior: motion && motion.matches ? 'auto' : 'smooth' });
    }

    if (previous) {
      on(previous, 'click', function () {
        scrollByPage(true);
      });
    }
    if (next) {
      on(next, 'click', function () {
        scrollByPage(false);
      });
    }

    /* Mouse drag-to-scroll (touch and trackpads scroll natively); a drag never ends in a click on a pill. */
    on(track, 'pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { id: event.pointerId, x: event.clientX, left: track.scrollLeft, moved: false };
    });
    on(track, 'pointermove', function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      var dx = event.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 5) {
        drag.moved = true;
        root.classList.add('is-dragging');
        if (track.setPointerCapture) track.setPointerCapture(drag.id);
      }
      if (drag.moved) track.scrollLeft = drag.left - dx;
    });
    function endDrag(event) {
      if (!drag || (event && event.pointerId !== drag.id)) return;
      if (drag.moved) suppressClick = true;
      drag = null;
      root.classList.remove('is-dragging');
    }
    on(track, 'pointerup', endDrag);
    on(track, 'pointercancel', endDrag);
    on(track, 'click', function (event) {
      if (!suppressClick) return;
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);
    on(track, 'dragstart', function (event) {
      event.preventDefault();
    });

    /* Keep the active pill in view (a collection page, or the editor's selected block), without moving the page. */
    function reveal(pill) {
      if (!pill) return;
      var pillBox = pill.getBoundingClientRect();
      var trackBox = track.getBoundingClientRect();
      if (pillBox.left >= trackBox.left && pillBox.right <= trackBox.right) return;
      track.scrollLeft += pillBox.left + pillBox.width / 2 - (trackBox.left + trackBox.width / 2);
    }

    on(root, 'shopify:block:select', function (event) {
      reveal(event.target && event.target.closest ? event.target.closest('.shop5-pills__pill') : null);
    });

    /* The row's own size (resize) and its pills' sizes (web font swap, editor changes) decide the overflow state. */
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(track);
      Array.prototype.forEach.call(track.children, function (pill) {
        resizeObserver.observe(pill);
      });
    } else {
      on(window, 'resize', update);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);

    update();
    reveal(track.querySelector('.shop5-pills__pill[aria-current="page"]'));

    return function destroy() {
      if (resizeObserver) resizeObserver.disconnect();
      cleanups.forEach(function (cleanup) {
        cleanup();
      });
      cleanups = [];
      root.classList.remove('is-dragging');
    };
  });

  // 2. Collections strip, best sellers, featured rows, quick add (docs/build/parts6h/home-products.js).
  /* ---------------------------------------------------------------- home products (collections strip, best sellers,
     featured collection rows, quick add of snippets/shop5-card.liquid; map C-collections-products.md C1.5, C2.5, C3.5)
     One part, four kinds of root:
     - section root data-shop5-kind="collections": previous and next buttons scroll two cards toward the start or the
       end edge (RTL scrollLeft is negative, so the sign comes from the computed direction), the progress line grows
       from 18 % to 100 % (Math.abs of scrollLeft), mouse drag scrolls (a drag never follows a link), cards enter once
       with a 70 ms stagger; the theme editor's block select scrolls the card into view.
     - data-shop5-kind="best-sellers": the reserved slots are filled from one Section Rendering request of the
       best-selling list (section 16 A9); each card's curtain, number colour and line play once (90 ms stagger).
     - data-shop5-kind="collection": the cards of the grid slide up once when the grid comes into view; a rotating row
       printed in another time bucket than the visitor's clock shows that bucket's order of its pool, read with one
       request (16 E).
     - form[data-shop5-quick-add] (one per one-size product card, any section): fetch to routes.cart_add_url + '.js';
       success: class is-added (icon swap), label "Added" for 2.4 s, window.Shop5Toast.show(text), then the vendor Cart
       re-renders the count and the mini cart on 'cart:refresh' (the drawer stays closed: product:added is never sent);
       refused add: the cart's own description in the toast as an alert. Without script the form posts and Shopify adds.
     The hidden start states are armed here (class is-ready), never in the markup; under reduced motion, in the theme
     editor and without IntersectionObserver everything is shown at once. */
  Shop5Parts.register('home-products', function (root) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var editor = !!(window.Shopify && window.Shopify.designMode);
    var animate = !reduce && !editor && 'IntersectionObserver' in window;
    var cleanups = [];

    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options || false);
      cleanups.push(function () {
        target.removeEventListener(type, handler, options || false);
      });
    }

    function destroyAll() {
      while (cleanups.length) {
        cleanups.pop()();
      }
    }

    /* Reveal: items get .is-in once they (or the target) come into view; stagger index in --s5-i. */
    function reveal(targets, onShow, stagger) {
      var list = Array.prototype.slice.call(targets);
      list.forEach(function (el, i) {
        el.style.setProperty('--s5-i', String(stagger ? stagger(i) : i));
      });
      if (!animate) {
        list.forEach(onShow);
        return;
      }
      root.classList.add('is-ready');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            onShow(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      list.forEach(function (el) {
        observer.observe(el);
      });
      cleanups.push(function () {
        observer.disconnect();
        root.classList.remove('is-ready');
      });
    }

    function addIn(el) {
      el.classList.add('is-in');
    }

    /* ---- quick add ---- */
    function initQuickAdd(form) {
      var button = form.querySelector('.shop5-card__btn');
      var label = form.querySelector('.shop5-card__label');
      if (!button || !label) return function () {};
      var original = label.textContent;
      var timer = 0;
      var busy = false;

      function toast(text, alert) {
        if (text && window.Shop5Toast && typeof window.Shop5Toast.show === 'function') {
          window.Shop5Toast.show(text, alert ? { alert: true } : undefined);
        }
      }

      function done() {
        busy = false;
        button.removeAttribute('aria-busy');
      }

      function onSubmit(event) {
        event.preventDefault();
        if (busy || button.classList.contains('is-added')) return;
        busy = true;
        button.setAttribute('aria-busy', 'true');
        fetch(form.getAttribute('action') + '.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin'
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then(function (result) {
            done();
            if (!result.ok) {
              toast((result.data && (result.data.description || result.data.message)) || form.getAttribute('data-error'), true);
              return;
            }
            button.classList.add('is-added');
            label.textContent = form.getAttribute('data-added') || original;
            toast(form.getAttribute('data-toast'), false);
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
            clearTimeout(timer);
            timer = setTimeout(function () {
              button.classList.remove('is-added');
              label.textContent = original;
            }, 2400);
          })
          .catch(function () {
            done();
            toast(form.getAttribute('data-error'), true);
          });
      }

      form.addEventListener('submit', onSubmit);
      return function destroy() {
        form.removeEventListener('submit', onSubmit);
        clearTimeout(timer);
        button.classList.remove('is-added');
        label.textContent = original;
      };
    }

    /* ---- collections strip ---- */
    function initStrip() {
      var track = root.querySelector('[data-shop5-track]');
      if (!track) return;
      var bar = root.querySelector('[data-shop5-bar]');
      var prev = root.querySelector('.shop5-cg2__arrow[data-dir="prev"]');
      var next = root.querySelector('.shop5-cg2__arrow[data-dir="next"]');
      var cards = track.querySelectorAll('.shop5-cg2__card');
      var frame = 0;

      function rtl() {
        return getComputedStyle(track).direction === 'rtl';
      }

      function step() {
        var card = cards[0];
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return card ? (card.getBoundingClientRect().width + gap) * 2 : 500;
      }

      function update() {
        frame = 0;
        var max = track.scrollWidth - track.clientWidth;
        var x = Math.abs(track.scrollLeft);
        var p = max > 0 ? Math.min(x / max, 1) : 0;
        if (bar) bar.style.setProperty('--shop5-cg2-progress', String(p));
        if (prev) prev.disabled = x < 4;
        if (next) next.disabled = x > max - 4;
      }

      function schedule() {
        if (!frame) frame = requestAnimationFrame(update);
      }

      /* Previous goes toward the start edge (right in Arabic, left in English), next toward the end edge. */
      function go(towardEnd) {
        var distance = step() * (towardEnd ? 1 : -1) * (rtl() ? -1 : 1);
        track.scrollBy({ left: distance, behavior: reduce ? 'auto' : 'smooth' });
      }

      if (prev) listen(prev, 'click', function () { go(false); });
      if (next) listen(next, 'click', function () { go(true); });
      listen(track, 'scroll', schedule, { passive: true });
      listen(window, 'resize', schedule);
      update();

      /* Mouse drag (touch keeps the native scroll with snapping). */
      var down = false;
      var moved = false;
      var startX = 0;
      var startLeft = 0;
      listen(track, 'pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        down = true;
        moved = false;
        startX = event.clientX;
        startLeft = track.scrollLeft;
      });
      listen(window, 'pointermove', function (event) {
        if (!down) return;
        var dx = event.clientX - startX;
        if (!moved && Math.abs(dx) > 5) {
          moved = true;
          track.classList.add('is-drag');
        }
        if (moved) track.scrollLeft = startLeft - dx;
      });
      listen(window, 'pointerup', function () {
        if (!down) return;
        down = false;
        track.classList.remove('is-drag');
      });
      listen(track, 'dragstart', function (event) {
        event.preventDefault();
      });

      /* Theme editor: show the selected collection block. */
      listen(root.closest('.shopify-section') || root, 'shopify:block:select', function (event) {
        var card = event.target.closest ? event.target.closest('.shop5-cg2__card') : null;
        if (!card || !cards.length) return;
        track.scrollTo({ left: card.offsetLeft - cards[0].offsetLeft, behavior: 'auto' });
      });

      reveal(cards, addIn);
      cleanups.push(function () {
        if (frame) cancelAnimationFrame(frame);
        track.classList.remove('is-drag');
      });
    }

    /* ---- Section Rendering: one GET, the grid matching selector in the answer (null on any failure) ---- */
    var dead = false;
    cleanups.push(function () {
      dead = true;
    });

    function fetchGrid(url, selector) {
      return fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (html) {
          if (dead || !html) return null;
          return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        })
        .catch(function () {
          return null;
        });
    }

    /* ---- rotation (section 16 E): the arithmetic of snippets/shop5-rotation-order.liquid, kept identical so the
       server's order and the browser's order of one bucket are the same. Pool positions (from 0) to show. ---- */
    var PRIMES = [5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53];

    function bucketNow(minutes) {
      return Math.floor(Date.now() / (minutes * 60000));
    }

    function rotationOrder(bucket, size, count) {
      var start = (bucket * 7919) % size;
      var k = (bucket * 31 + 7) % 14;
      var step = 53;
      for (var j = 0; j < 14; j += 1) {
        if (size % PRIMES[(k + j) % 14] !== 0) {
          step = PRIMES[(k + j) % 14];
          break;
        }
      }
      var order = [];
      for (var i = 0; i < Math.min(count, size); i += 1) {
        order.push((i * step + start) % size);
      }
      return order;
    }

    /* ---- best sellers (section 16 A9): the slots are replaced by the first data-count cards of the best-selling
       feed (with rotation: the bucket's order of the feed's pool), one for one, so the row keeps its height; the
       numbers follow the shown order and the cards then play their entry motion. Slots the feed cannot fill stay as
       invisible boxes (shop5-bs-card--spare). A failed or empty feed is asked once more after BS_RETRY_MS; when that
       fails too, the slots give way to the noscript's best-selling list link, centred in a box held at the grid's
       painted height (--shop5-bs-hold), so the section never collapses after its first paint. ---- */
    var BS_RETRY_MS = 2000;

    function initBestSellers() {
      var grid = root.querySelector('[data-shop5-bs-src]');
      if (!grid) {
        reveal(root.querySelectorAll('.shop5-bs-card[data-shop5-reveal-item]'), addIn);
        return;
      }
      var count = parseInt(grid.getAttribute('data-count'), 10) || 0;
      var minutes = parseInt(grid.getAttribute('data-shop5-rotate-min'), 10);
      var src = grid.getAttribute('data-shop5-bs-src');
      var retry = 0;
      cleanups.push(function () {
        window.clearTimeout(retry);
      });

      function pick(feed) {
        var pool = feed ? Array.prototype.slice.call(feed.querySelectorAll('.shop5-bs-card')) : [];
        return minutes > 0 && !editor
          ? rotationOrder(bucketNow(minutes), pool.length, count).map(function (i) { return pool[i]; })
          : pool.slice(0, count);
      }

      function fill(cards) {
        var slots = Array.prototype.slice.call(grid.querySelectorAll('.shop5-bs-card--slot'));
        slots.forEach(function (slot, i) {
          if (cards[i]) slot.replaceWith(cards[i]);
          else slot.classList.add('shop5-bs-card--spare');
        });
        cards.forEach(function (card, i) {
          var num = card.querySelector('.shop5-bs-card__num');
          if (num) num.textContent = (i < 9 ? '0' : '') + (i + 1);
        });
        grid.removeAttribute('data-shop5-bs-src');
        Shop5Parts.start(grid);
        reveal(cards, addIn);
      }

      function fallBack() {
        // With script on, a noscript's content is its text: the same anchor, parsed by DOMParser.
        var noscript = root.querySelector('noscript');
        var link = noscript ? new DOMParser().parseFromString(noscript.textContent, 'text/html').querySelector('a') : null;
        grid.style.setProperty('--shop5-bs-hold', Math.round(grid.getBoundingClientRect().height) + 'px');
        grid.classList.add('shop5-bs__grid--fallback');
        grid.removeAttribute('data-shop5-bs-src');
        if (link) grid.replaceChildren(link);
        else grid.replaceChildren();
      }

      function load(last) {
        fetchGrid(src, '[data-shop5-bs-feed]').then(function (feed) {
          if (dead) return;
          var cards = pick(feed);
          if (cards.length) fill(cards);
          else if (last) fallBack();
          else retry = window.setTimeout(function () { load(true); }, BS_RETRY_MS);
        });
      }

      load(false);
    }

    /* ---- featured collection row ---- */
    function stagger(grid) {
      Array.prototype.forEach.call(grid.querySelectorAll('.shop5-card'), function (card, i) {
        card.style.setProperty('--s5-i', String(i % 4));
      });
    }

    /* Rotation: the server printed the cards of bucket data-shop5-rotate, but Shopify serves cached renders whose
       time is minutes old. When the visitor's clock is in another bucket, the row asks once for its pool - the section
       rendered on the collection's URL, which does not depend on time - and shows the clock bucket's order of it;
       same count, same card size, so nothing moves.
       The printed cards of such a row are about to be thrown away, so none of their pictures may be downloaded:
       Chrome starts lazy pictures 1250 to 2500 px ahead of the screen, further than any swap margin. A stale row
       therefore parks its pictures that have not finished loading (srcset and src kept in data attributes, the
       picture hidden in its sized box, shop5-home.css) as soon as the script runs, and asks for the pool in the
       first idle moment after that (the rows sit below the first screen, so the first paint and its largest picture
       go first). If the pool cannot be used, the parked pictures are put back and load as before. */
    function whenIdle(fn) {
      if ('requestIdleCallback' in window) {
        var idle = window.requestIdleCallback(fn, { timeout: 1000 });
        cleanups.push(function () {
          window.cancelIdleCallback(idle);
        });
      } else {
        var timer = window.setTimeout(fn, 200);
        cleanups.push(function () {
          window.clearTimeout(timer);
        });
      }
    }

    function park(grid) {
      var parked = Array.prototype.filter.call(grid.querySelectorAll('img'), function (img) {
        return !img.complete && (img.hasAttribute('srcset') || img.hasAttribute('src'));
      });
      parked.forEach(function (img) {
        if (img.hasAttribute('srcset')) img.setAttribute('data-shop5-srcset', img.getAttribute('srcset'));
        if (img.hasAttribute('src')) img.setAttribute('data-shop5-src', img.getAttribute('src'));
        img.removeAttribute('srcset');
        img.removeAttribute('src');
        img.setAttribute('data-shop5-parked', '');
      });
      return function unpark() {
        parked.forEach(function (img) {
          if (img.hasAttribute('data-shop5-srcset')) img.setAttribute('srcset', img.getAttribute('data-shop5-srcset'));
          if (img.hasAttribute('data-shop5-src')) img.setAttribute('src', img.getAttribute('data-shop5-src'));
          img.removeAttribute('data-shop5-srcset');
          img.removeAttribute('data-shop5-src');
          img.removeAttribute('data-shop5-parked');
        });
      };
    }

    function refreshRow(grid) {
      var minutes = parseInt(grid.getAttribute('data-shop5-rotate-min'), 10);
      var printed = parseInt(grid.getAttribute('data-shop5-rotate'), 10);
      var src = grid.getAttribute('data-shop5-rotate-src');
      if (editor || !src || !(minutes > 0) || isNaN(printed) || bucketNow(minutes) === printed) return;
      var count = grid.querySelectorAll('.shop5-card').length;
      var unpark = park(grid);
      cleanups.push(unpark);

      whenIdle(function () {
        fetchGrid(src, '[data-shop5-pool]').then(function (poolGrid) {
          if (dead) return;
          var pool = poolGrid ? poolGrid.querySelectorAll('.shop5-card') : [];
          var bucket = bucketNow(minutes);
          var cards = rotationOrder(bucket, pool.length, count).map(function (i) { return pool[i]; });
          if (cards.length !== count) {
            unpark();
            return;
          }
          Shop5Parts.stop(grid);
          grid.replaceChildren.apply(grid, cards);
          grid.setAttribute('data-shop5-rotate', String(bucket));
          stagger(grid);
          Shop5Parts.start(grid);
        });
      });
    }

    function initRow() {
      var grid = root.querySelector('[data-shop5-grid]');
      if (!grid) return;
      stagger(grid);
      reveal([grid], addIn, function () { return 0; });
      refreshRow(grid);
    }

    if (root.hasAttribute('data-shop5-quick-add')) {
      return initQuickAdd(root);
    }

    var kind = root.getAttribute('data-shop5-kind');
    if (kind === 'collections') initStrip();
    else if (kind === 'best-sellers') initBestSellers();
    else if (kind === 'collection') initRow();

    return function destroy() {
      destroyAll();
    };
  });

  // 3. App download: phone tilt (docs/build/parts6h/home-banners.js).
  /* ---------------------------------------------------------------- home app download: iPhone scroll tilt */
  /* sections/shop5-home-app.liquid; owner design index.html 2236-2249 (spec D-banners-features-app.md D3.5), per section
     root. The design's maths unchanged: p = how far the phone has passed through the viewport (0 when its top meets the
     bottom of the screen, 1 when its bottom leaves the top); entry e = ease-out-cubic over p .08-.50, exit k = linear over
     p .62-1. The values are written as custom properties on the phone (--shop5-iph-rx/-ry/-rz/-ty); the CSS composes them
     (rotateY and rotateZ times --s5-flip, so English pages lean the mirrored way). The scroll listener is attached only
     while the phone is near the screen (IntersectionObserver); nothing runs under reduced motion or when the section's
     tilt setting is off (no data-shop5-tilt). The float is CSS only. */
  Shop5Parts.register('home-app', function (root) {
    var wrap = root.querySelector('[data-shop5-tilt]');
    if (!wrap) {
      return function destroy() {};
    }
    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var observer = null;
    var listening = false;
    var frame = 0;

    function clamp(v) {
      return Math.max(0, Math.min(1, v));
    }

    function update() {
      frame = 0;
      var r = wrap.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var p = clamp((vh - r.top) / (vh + r.height));
      var e = 1 - Math.pow(1 - clamp((p - 0.08) / 0.42), 3);
      var k = clamp((p - 0.62) / 0.38);
      wrap.style.setProperty('--shop5-iph-ry', (-24 * (1 - e) + 9 * k).toFixed(2) + 'deg');
      wrap.style.setProperty('--shop5-iph-rx', (14 * (1 - e) - 4 * k).toFixed(2) + 'deg');
      wrap.style.setProperty('--shop5-iph-rz', (-5 * (1 - e)).toFixed(2) + 'deg');
      wrap.style.setProperty('--shop5-iph-ty', (70 * (1 - e) - 16 * k).toFixed(1) + 'px');
    }

    function schedule() {
      if (!frame) {
        frame = window.requestAnimationFrame(update);
      }
    }

    function attach() {
      if (listening) return;
      listening = true;
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      update();
    }

    function detach() {
      if (!listening) return;
      listening = false;
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      if (frame) {
        window.cancelAnimationFrame(frame);
        frame = 0;
      }
    }

    function clear() {
      wrap.style.removeProperty('--shop5-iph-ry');
      wrap.style.removeProperty('--shop5-iph-rx');
      wrap.style.removeProperty('--shop5-iph-rz');
      wrap.style.removeProperty('--shop5-iph-ty');
    }

    function start() {
      if (reduce && reduce.matches) return;
      // The values for the current scroll position are set at once (the design runs its update on load), so a phone
      // first seen mid-page is not drawn flat and then snapped.
      update();
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          if (entries[entries.length - 1].isIntersecting) {
            attach();
          } else {
            // Leaving: one last update so the phone rests at its entry or exit pose, then stop listening.
            update();
            detach();
          }
        }, { rootMargin: '200px 0px' });
        observer.observe(wrap);
      } else {
        attach();
      }
    }

    function stop() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      detach();
      clear();
    }

    function onReduceChange() {
      stop();
      start();
    }

    if (reduce) {
      if (reduce.addEventListener) reduce.addEventListener('change', onReduceChange);
      else if (reduce.addListener) reduce.addListener(onReduceChange);
    }
    start();

    return function destroy() {
      stop();
      if (reduce) {
        if (reduce.removeEventListener) reduce.removeEventListener('change', onReduceChange);
        else if (reduce.removeListener) reduce.removeListener(onReduceChange);
      }
    };
  });

  // 4. SEO intro (docs/build/parts6h/home-seo.js).
  /* ---------------------------------------------------------------- home SEO intro (sections/shop5-home-seo.liquid) */
  /* Owner design `#seo-intro` script (index.html 2010-2019; spec E-seo-footer.md A6 and C1), per section root:
     1. Reveal: one-shot IntersectionObserver (25 %) adds .is-in; the hidden start state is armed here (.shop5-seo--anim),
        never in the markup, and not at all under reduced motion or in the theme editor.
     2. Dots follow the phone row's scroll position (Math.abs: RTL scrollLeft is negative).
     3. Auto-advance (phones, <= 768 px) every N seconds after the reveal, only while the row is on screen and the tab is
        visible; it pauses while the row is hovered or focused, a touch stops it for good (the shopper took control:
        WCAG 2.2.2, as the hero's thumbnails do); off under reduced motion.
        The next tile's offset is measured from the first tile, so the same code runs right to left and left to right.
     4. Theme editor: selecting a tile block scrolls the row to it and pauses the row until it is deselected. */
  Shop5Parts.register('home-seo', function (root) {
    var track = root.querySelector('[data-shop5-seo-track]');
    var dots = root.querySelectorAll('.shop5-seo__dot');
    var phone = window.matchMedia('(max-width: 768px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var editor = !!(window.Shopify && window.Shopify.designMode);
    var seconds = parseInt(root.getAttribute('data-autoplay-seconds'), 10) || 3;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var revealObserver = null;
    var viewObserver = null;
    var timer = 0;
    var frame = 0;
    var hovered = false;
    var focused = false;
    var touched = false;
    var selected = false;
    var onScreen = false;

    function reveal() {
      root.classList.add('is-in');
      if (revealObserver) {
        revealObserver.disconnect();
        revealObserver = null;
      }
    }

    if (reduce.matches || editor || !('IntersectionObserver' in window)) {
      reveal();
    } else {
      root.classList.add('shop5-seo--anim');
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Also when the page opens already scrolled past the block (a restored scroll position).
          if (entry.isIntersecting || entry.boundingClientRect.bottom < 0) reveal();
        });
      }, { threshold: 0.25 });
      revealObserver.observe(root);
    }

    if (!track) {
      return function destroy() {
        if (revealObserver) revealObserver.disconnect();
      };
    }

    var tiles = track.querySelectorAll('.shop5-seo__tile');

    function offsetOf(i) {
      return tiles[i].offsetLeft - tiles[0].offsetLeft;
    }

    function currentIndex() {
      if (tiles.length < 2) return 0;
      var step = Math.abs(offsetOf(1)) || 1;
      var i = Math.round(Math.abs(track.scrollLeft) / step);
      return Math.max(0, Math.min(tiles.length - 1, i));
    }

    function paintDots() {
      frame = 0;
      var on = currentIndex();
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-on', i === on);
    }

    function onScroll() {
      if (!frame) frame = window.requestAnimationFrame(paintDots);
    }

    function goTo(i) {
      track.scrollTo({ left: offsetOf(i), behavior: reduce.matches ? 'auto' : 'smooth' });
    }

    function tick() {
      if (!autoplay || reduce.matches || !phone.matches || document.hidden) return;
      if (hovered || focused || touched || selected || !onScreen || !root.classList.contains('is-in')) return;
      if (tiles.length < 2 || track.scrollWidth <= track.clientWidth + 1) return;
      var atEnd = Math.abs(track.scrollLeft) + track.clientWidth >= track.scrollWidth - 6;
      goTo(atEnd ? 0 : currentIndex() + 1);
    }

    function onEnter() { hovered = true; }
    function onLeave() { hovered = false; }
    function onFocusIn() { focused = true; }
    function onFocusOut(event) {
      if (!root.contains(event.relatedTarget)) focused = false;
    }
    /* A touch is the shopper taking control: the row never moves by itself again (WCAG 2.2.2; README 5.10 "pauses when
       the user touches it"). */
    function onTouch() {
      touched = true;
      window.clearInterval(timer);
      timer = 0;
    }

    function onSelect(event) {
      for (var i = 0; i < tiles.length; i++) {
        if (tiles[i] === event.target || tiles[i].contains(event.target)) {
          selected = true;
          reveal();
          goTo(i);
          return;
        }
      }
    }
    function onDeselect() { selected = false; }

    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('mouseenter', onEnter);
    track.addEventListener('mouseleave', onLeave);
    track.addEventListener('touchstart', onTouch, { passive: true });
    root.addEventListener('focusin', onFocusIn);
    root.addEventListener('focusout', onFocusOut);
    root.addEventListener('shopify:block:select', onSelect);
    root.addEventListener('shopify:block:deselect', onDeselect);

    if ('IntersectionObserver' in window) {
      viewObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { onScreen = entry.isIntersecting; });
      });
      viewObserver.observe(track);
    } else {
      onScreen = true;
    }

    if (autoplay && tiles.length > 1) timer = window.setInterval(tick, seconds * 1000);

    return function destroy() {
      window.clearInterval(timer);
      if (frame) window.cancelAnimationFrame(frame);
      if (revealObserver) revealObserver.disconnect();
      if (viewObserver) viewObserver.disconnect();
      track.removeEventListener('scroll', onScroll);
      track.removeEventListener('mouseenter', onEnter);
      track.removeEventListener('mouseleave', onLeave);
      track.removeEventListener('touchstart', onTouch);
      root.removeEventListener('focusin', onFocusIn);
      root.removeEventListener('focusout', onFocusOut);
      root.removeEventListener('shopify:block:select', onSelect);
      root.removeEventListener('shopify:block:deselect', onDeselect);
    };
  });
})();
